// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"EQ-z","categoryName":"FQ-z","categoryNameSearchHeader":"GQ-z","categoryContent":"HQ-z","bottomAligned":"IQ-z","image":"JQ-z","imageNoBackground":"KQ-z"};